export const oyri_item = [
    {
      /*   "nombre": "Código de Conducta de la Oficialía Mayor", */
        "url": "/pdf/OyRI/Lineamientos_Grales_Estructuras_Organicas.pdf",
        "icono": "oyri1.png"
    },
    {
      /*   "nombre": "Código de Ética de la Administración Pública del Estado de Hidalgo", */
        "url": "/pdf/OyRI/Guia_manual_de_organizacion.pdf",
        "icono": "oyri2.png"
    },
    {
        /*   "nombre": "Código de Ética de la Administración Pública del Estado de Hidalgo", */
          "url": "/pdf/OyRI/Guia_manual_de_procedimientos.pdf",
          "icono": "oyri3.png"
      },
   

]